package org.moxultimate.topwithmox.wallpaper.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * WallpaperSearchRequest
 * JSON body for POST /wallpapers/search.
 *
 * @param query Free text; every word must partially match the wallpaper's tags or title.
 * @param types Active type chips, lowercase (OR between them); empty means no type filter.
 * @param series Active series chips (OR between them); empty means no series filter.
 * @param has360 When true, only wallpapers that have a 360° panorama.
 * @param beforeId Pagination cursor — id of the last wallpaper from the previous page.
 */
@Serializable
data class WallpaperSearchRequest(
    @SerialName("query") val query: String,
    @SerialName("types") val types: List<String> = emptyList(),
    @SerialName("series") val series: List<String> = emptyList(),
    @SerialName("has360") val has360: Boolean = false,
    @SerialName("beforeId") val beforeId: Long? = null,
)
